export default "__VITE_ASSET__hWfffnM6__"